import Logger from 'components/Common/Logger';
import http from 'utils/http';
import {
  call, put,
} from 'redux-saga/effects';
import {
  deleteFlowNodeError,
  fetchFlowNodeCompleteDetails,
  setCreateNodeSuccess,
} from 'redux/actions/FlowAction';
import { showAlert } from 'redux/actions/AlertActions';


export function* createQuestionNode({ url, payload }) {
  const {
    nodeId, nodePayload, isEditable, orgId, crId, crFlowId,
  } = payload;
  const { error, node } = yield call(http.post, url, nodePayload);

  if (error) {
    Logger.error(error, `Could not create question node. Url: ${url}. Error: ${error}`);
    yield put(showAlert({ message: error, type: 'error' }));
    return yield put(deleteFlowNodeError(nodePayload));
  }

  yield put(showAlert({ message: 'Question node successfully create', type: 'success' }));
  yield put(setCreateNodeSuccess({ node: { ...node, isEditable }, oldNodeId: nodeId }));

  // Automatically fetch node complete details after successful creation
  if (node?.ID) {
    yield put(fetchFlowNodeCompleteDetails({
      orgId,
      crId,
      crFlowId,
      nodeId: node.ID,
      flowVersion: -1,
    }));
  }

  return node;
}
